var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:['xiaobu-loading-mask', _vm.show ? 'show' : 'hide'],on:{"scroll":function($event){$event.stopPropagation();}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('span',{staticClass:"loading-dot loading-dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])])
}]

export { render, staticRenderFns }